/** 系统初始默认密码，首次登录需强制修改 */
export const DEFAULT_INITIAL_PASSWORD = 'ArgusMind';
